import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AllocateConsumerFromBillingitemWizardEffects } from './effects';
import * as fromAllocateConsumerFromBillingitemWizard from './reducer';

export function provideAllocateConsumerFromBillingitemWizardStoreV26(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(
      fromAllocateConsumerFromBillingitemWizard.allocateConsumerFromBillingitemWizardFeatureKey,
      fromAllocateConsumerFromBillingitemWizard.reducer,
    ),
    provideEffects(AllocateConsumerFromBillingitemWizardEffects),
  ]);
}
